// Chess pieces rendered as the standard cburnett SVG set (the lichess /
// Wikipedia pieces — public domain, instantly recognizable, flat vector).
//
// The previous hand-drawn paths were unrecognizable; cburnett is the canonical
// set. The white/black coloring is baked into the markup, identical on every
// platform (unlike the old OS-font Unicode glyphs).

import type { JSX } from "react";
import { CBURNETT } from "@chess/shared";

export interface PieceSvgProps {
  /** Piece char: uppercase = white, lowercase = black (K,Q,R,B,N,P / k,q,...). */
  piece: string;
  size: number;
}

export function PieceSvg({ piece, size }: PieceSvgProps): JSX.Element | null {
  const data = CBURNETT[piece];
  if (!data) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox={data.viewBox}
      style={{ display: "block", pointerEvents: "none" }}
      aria-hidden
      dangerouslySetInnerHTML={{ __html: data.inner }}
    />
  );
}
